/* Matted – Visualiseur de sol (oct. 2026) */
(function () {
  var app = document.getElementById('mv-app');
  var dataEl = document.getElementById('mv-data');
  if (!app || !dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var R = D.ranges || [];
  if (!R.length) return;

  var $ = function (s, el) { return (el || app).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || app).querySelectorAll(s)); };
  var stage = $('.mv-stage'), before = $('.mv-img--before'), after = $('.mv-img--after');
  var msg = $('.mv-msg'), go = $('.mv-go'), done = $('.mv-done'), bar = $('.mv-bar i'), loadT = $('.mv-load__t');
  var S = { r: R[0], sel: {}, tile: [null, null], pose: 'uni', photo: null, ratio: '4:3', result: null, busy: false };

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function say(t, err) { msg.textContent = t || ''; msg.classList.toggle('is-err', !!err); }
  function img(u, w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 800); }
  function chipIdx(r) { var a = []; r.o.forEach(function (n, i) { if (!/couleur/i.test(n)) a.push(i); }); return a; }
  function colIdx(r) { var a = []; r.o.forEach(function (n, i) { if (/couleur/i.test(n)) a.push(i); }); return a.length ? a : [r.o.length - 1]; }
  function label(r, v) { return colIdx(r).map(function (i) { return v.o[i]; }).join(' · '); }
  var FAM = R.map(function (r) { return r.f; }).filter(function (x, i, a) { return a.indexOf(x) === i; });

  /* ---------- Choix de la dalle ---------- */
  function ranges() {
    $('[data-ranges]').innerHTML = FAM.map(function (f) {
      return '<button type="button" class="mv-chip" data-f="' + esc(f) + '" aria-pressed="' + (f === S.r.f) + '">' + esc(f) + '</button>';
    }).join('');
    var vers = R.filter(function (r) { return r.f === S.r.f; });
    $('[data-vers]').innerHTML = vers.length > 1 ? '<div class="mv-l">Version</div><div class="mv-chips" role="group">' + vers.map(function (r) {
      return '<button type="button" class="mv-chip" data-r="' + R.indexOf(r) + '" aria-pressed="' + (r === S.r) + '">' + esc(r.t) + '</button>';
    }).join('') + '</div>' : '';
  }
  function pickDefaults() {
    var r = S.r; S.sel = {};
    chipIdx(r).forEach(function (i) {
      var vals = uniq(r.v.map(function (v) { return v.o[i]; }));
      S.sel[i] = vals.indexOf('Standard') > -1 ? 'Standard' : vals[0];
    });
  }
  function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
  function matching() {
    var r = S.r;
    var ci = chipIdx(r);
    return r.v.filter(function (v) {
      for (var k = 0; k < ci.length; k++) if (v.o[ci[k]] !== S.sel[ci[k]]) return false;
      return true;
    });
  }
  function opts() {
    var r = S.r, h = '', ci = chipIdx(r);
    for (var n = 0; n < ci.length; n++) {
      var i = ci[n], before = ci.slice(0, n);
      var prev = r.v.filter(function (v) { for (var j = 0; j < before.length; j++) if (v.o[before[j]] !== S.sel[before[j]]) return false; return true; });
      var vals = uniq(prev.map(function (v) { return v.o[i]; }));
      if (vals.indexOf(S.sel[i]) < 0) S.sel[i] = vals[0];
      if (vals.length < 2) continue;
      h += '<div class="mv-l">' + esc(r.o[i]) + '</div><div class="mv-chips" role="group">' + vals.map(function (x) {
        return '<button type="button" class="mv-chip" data-o="' + i + '" data-val="' + esc(x) + '" aria-pressed="' + (x === S.sel[i]) + '">' + esc(x.replace(/\s*\(\d+\)/, '')) + '</button>';
      }).join('') + '</div>';
    }
    $('[data-opts]').innerHTML = h;
    swatches();
  }
  function swatches() {
    var list = matching();
    [0, 1].forEach(function (k) {
      var cur = S.tile[k];
      if (!cur || list.indexOf(cur) < 0) S.tile[k] = list[k === 1 && list.length > 1 ? (list[0] === S.tile[0] ? 1 : 0) : 0] || null;
      $('[data-sw="' + k + '"]').innerHTML = list.map(function (v, i) {
        return '<button type="button" class="mv-swatch" data-k="' + k + '" data-i="' + i + '" aria-pressed="' + (v === S.tile[k]) + '"><img src="' + esc(img(v.i, 160)) + '" alt="" loading="lazy" width="80" height="80"><span>' + esc(label(S.r, v)) + '</span></button>';
      }).join('');
    });
    if (S.tile[1] === S.tile[0] && list.length > 1) { S.tile[1] = list.filter(function (v) { return v !== S.tile[0]; })[0]; swatches(); return; }
    $('[data-product]').href = S.r.url + (S.tile[0] ? '?variant=' + S.tile[0].id : '');
    ready();
  }
  function ready() { go.disabled = !(S.photo && S.tile[0]) || S.busy; }

  app.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b || !app.contains(b)) return;
    if (b.dataset.f != null) { S.r = R.filter(function (r) { return r.f === b.dataset.f; })[0]; S.tile = [null, null]; pickDefaults(); ranges(); opts(); }
    else if (b.dataset.r != null) { S.r = R[+b.dataset.r]; S.tile = [null, null]; pickDefaults(); ranges(); opts(); }
    else if (b.dataset.o != null) { S.sel[+b.dataset.o] = b.dataset.val; opts(); }
    else if (b.dataset.k != null) { S.tile[+b.dataset.k] = matching()[+b.dataset.i]; swatches(); }
    else if (b.dataset.pose) {
      S.pose = b.dataset.pose;
      $$('[data-pose]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      $('.mv-b2').hidden = S.pose !== 'damier';
    }
    else if (b.dataset.act === 'download') download();
    else if (b.dataset.act === 'share') share();
    else if (b.dataset.act === 'newphoto') reset();
  });

  /* ---------- Photo ---------- */
  $$('input[type=file]').forEach(function (inp) { inp.addEventListener('change', function () { if (inp.files[0]) load(inp.files[0]); inp.value = ''; }); });
  ['dragover', 'dragenter'].forEach(function (t) { stage.addEventListener(t, function (e) { e.preventDefault(); stage.classList.add('is-over'); }); });
  ['dragleave', 'drop'].forEach(function (t) { stage.addEventListener(t, function () { stage.classList.remove('is-over'); }); });
  stage.addEventListener('drop', function (e) { e.preventDefault(); var f = e.dataTransfer.files[0]; if (f) load(f); });

  function nearest(w, h) {
    var a = w / h, best = '4:3', d = 9;
    ['1:1', '3:4', '4:3', '9:16', '16:9', '2:3', '3:2', '4:5', '5:4'].forEach(function (r) {
      var p = r.split(':'), x = Math.abs(Math.log(a / (p[0] / p[1])));
      if (x < d) { d = x; best = r; }
    });
    return best;
  }
  function load(file) {
    if (!/^image\//.test(file.type)) { say('Ce fichier n\'est pas une image.', true); return; }
    say('Préparation de la photo…');
    var url = URL.createObjectURL(file), im = new Image();
    im.onload = function () {
      var m = 1536, s = Math.min(1, m / Math.max(im.naturalWidth, im.naturalHeight));
      var c = document.createElement('canvas');
      c.width = Math.round(im.naturalWidth * s); c.height = Math.round(im.naturalHeight * s);
      c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      S.photo = c.toDataURL('image/jpeg', 0.86);
      S.ratio = nearest(c.width, c.height);
      before.src = S.photo; S.result = null;
      app.classList.add('mv--photo'); app.classList.remove('mv--done'); done.hidden = true;
      say('Choisissez votre dalle puis cliquez sur « Voir mon sol ».');
      ready();
      if (window.matchMedia('(max-width:989px)').matches) $('.mv-panel').scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    im.onerror = function () { URL.revokeObjectURL(url); say('Impossible de lire cette photo. Essayez au format JPEG ou PNG.', true); };
    im.src = url;
  }

  /* ---------- Rendu ---------- */
  var steps = ['Analyse de votre pièce…', 'Repérage du sol…', 'Pose de vos dalles…', 'Raccord des joints…', 'Lumière et reflets…', 'Dernières finitions…'];
  var timer;
  function progress(on) {
    clearInterval(timer);
    if (!on) { bar.style.width = '100%'; return; }
    var t0 = Date.now();
    bar.style.width = '0';
    timer = setInterval(function () {
      var s = (Date.now() - t0) / 1000;
      bar.style.width = Math.min(95, 100 * (1 - Math.exp(-s / 14))) + '%';
      loadT.textContent = steps[Math.min(steps.length - 1, Math.floor(s / 5))];
    }, 400);
  }
  /* Plan de pose 4 x 4 (damier, lattes bois) : guide visuel envoyé avec la demande */
  function loadImg(u) { return new Promise(function (ok, ko) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { ok(i); }; i.onerror = ko; i.src = u; }); }
  function crop(im) {
    var c = document.createElement('canvas'); c.width = im.width; c.height = im.height;
    var x = c.getContext('2d'); x.drawImage(im, 0, 0);
    var W = c.width, H = c.height, d = x.getImageData(0, 0, W, H).data, bg = [d[0], d[1], d[2], d[3]];
    var x0 = W, y0 = H, x1 = 0, y1 = 0;
    for (var y = 0; y < H; y += 2) for (var i = 0; i < W; i += 2) {
      var p = (y * W + i) * 4, a = d[p + 3], df = Math.abs(d[p] - bg[0]) + Math.abs(d[p + 1] - bg[1]) + Math.abs(d[p + 2] - bg[2]);
      if (!(a < 20 || (bg[3] > 200 && df < 40))) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 <= x0 || y1 <= y0) return { im: im, sx: 0, sy: 0, sw: W, sh: H };
    var m = Math.round(Math.min(x1 - x0, y1 - y0) * 0.02);
    return { im: im, sx: x0 + m, sy: y0 + m, sw: x1 - x0 - 2 * m, sh: y1 - y0 - 2 * m };
  }
  function motif(a, b, rot) {
    return Promise.all([loadImg(img(a, 500)), loadImg(img(b || a, 500))]).then(function (ims) {
      var A = crop(ims[0]), B = crop(ims[1]), n = 4, px = 800, s = px / n;
      var c = document.createElement('canvas'); c.width = c.height = px;
      var x = c.getContext('2d'); x.fillStyle = '#333'; x.fillRect(0, 0, px, px);
      for (var r = 0; r < n; r++) for (var k = 0; k < n; k++) {
        var odd = (r + k) % 2, t = odd ? B : A;
        x.save(); x.translate(k * s + s / 2, r * s + s / 2); if (rot && odd) x.rotate(Math.PI / 2);
        x.drawImage(t.im, t.sx, t.sy, t.sw, t.sh, -s / 2 + 1, -s / 2 + 1, s - 2, s - 2); x.restore();
      }
      return c.toDataURL('image/jpeg', 0.85);
    }).catch(function () { return ''; });
  }
  go.addEventListener('click', function () {
    if (go.disabled) return;
    var damier = S.pose === 'damier' && S.tile[1];
    var tiles = [img(S.tile[0].i, 800)];
    if (damier) tiles.push(img(S.tile[1].i, 800));
    var style = /ardoise/i.test(S.tile[0].o.join(' ')) ? 'ardoise' : 'bois';
    var lattes = S.r.k === 'tereco' && style === 'bois';
    var couleurs = [label(S.r, S.tile[0])]; if (damier) couleurs.push(label(S.r, S.tile[1]));
    S.busy = true; ready();
    app.classList.add('mv--busy'); app.classList.remove('mv--done'); done.hidden = true;
    say(''); progress(true);
    stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    (damier || lattes ? motif(S.tile[0].i, damier ? S.tile[1].i : null, lattes) : Promise.resolve('')).then(function (m) {
      return fetch(D.api, {
        method: 'POST', headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ photo: S.photo, gamme: S.r.k, style: style, tuiles: tiles, pose: damier ? 'damier' : 'uni', ratio: S.ratio, couleurs: couleurs, motif: m })
      });
    }).then(function (r) { return r.json().then(function (d) { return { s: r.status, d: d }; }); })
      .then(function (x) {
        if (x.d && x.d.image) {
          S.result = x.d.image;
          after.onload = function () { app.classList.add('mv--done'); setX(50); };
          after.src = x.d.image;
          done.hidden = false;
          var left = x.d.reste;
          say('Faites glisser le curseur pour comparer avant / après.' + (left != null ? ' Rendus restants aujourd\'hui : ' + left + '.' : ''));
          track('visualiseur_rendu');
        } else if (x.s === 429) {
          say(x.d && x.d.raison === 'jour' ? 'Le visualiseur a atteint sa limite du jour. Revenez demain, ou envoyez-nous votre photo via la page contact : nous vous préparons le rendu.' : 'Vous avez atteint la limite de 5 rendus par jour. Revenez demain, ou envoyez-nous votre photo : nous vous préparons le rendu.', true);
        } else {
          say('Le rendu n\'a pas pu être créé. Réessayez dans un instant, avec une photo bien cadrée sur le sol.', true);
        }
      })
      .catch(function () { say('Connexion interrompue. Vérifiez votre réseau et réessayez.', true); })
      .then(function () { progress(false); S.busy = false; app.classList.remove('mv--busy'); ready(); });
  });

  /* ---------- Avant / après ---------- */
  var rg = $('.mv-range');
  function setX(v) { app.style.setProperty('--x', v + '%'); rg.value = v; }
  rg.addEventListener('input', function () { setX(rg.value); });

  function blob() { return fetch(S.result).then(function (r) { return r.blob(); }); }
  function download() {
    if (!S.result) return;
    var a = document.createElement('a');
    a.href = S.result; a.download = 'mon-sol-matted.' + (/png/.test(S.result.slice(0, 30)) ? 'png' : 'jpg');
    document.body.appendChild(a); a.click(); a.remove();
  }
  function share() {
    if (!S.result) return;
    blob().then(function (b) {
      var f = new File([b], 'mon-sol-matted.' + (b.type === 'image/png' ? 'png' : 'jpg'), { type: b.type });
      if (navigator.canShare && navigator.canShare({ files: [f] })) return navigator.share({ files: [f], title: 'Mon sol Matted', text: 'Mon futur sol en dalles clipsables – matted.fr' });
      download();
    }).catch(function () {});
  }
  function reset() {
    S.photo = null; S.result = null;
    app.classList.remove('mv--photo', 'mv--done'); done.hidden = true; say(''); ready();
    stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function track(n) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, {}); } catch (e) {} }

  /* Présélection depuis une fiche produit : ?g=poignée&v=variante */
  (function () {
    var q = new URLSearchParams(location.search), g = q.get('g'), vid = +q.get('v');
    var r = g && R.filter(function (x) { return x.h === g; })[0];
    if (r) S.r = r;
    pickDefaults();
    var v = vid && S.r.v.filter(function (x) { return x.id === vid; })[0];
    if (v) { chipIdx(S.r).forEach(function (i) { S.sel[i] = v.o[i]; }); S.tile[0] = v; }
  })();
  ranges(); opts();
})();
